export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS';
export const SET_PAYMENT_PAYLOAD = 'SET_PAYMENT_PAYLOAD';
export const SET_IS_CLEANING_IN_PROGRESS = 'SET_IS_CLEANING_IN_PROGRESS';
export const SET_PAY_NOW_ACTIVITY_ID = 'SET_PAY_NOW_ACTIVITY_ID';
export const SET_INVOICE_DATA = 'SET_INVOICE_DATA';
export const SET_IS_CHARGE_FLOW = 'SET_IS_CHARGE_FLOW';
export const SET_PAY_NOW_ENROLLMENT_DATA = 'SET_PAY_NOW_ENROLLMENT_DATA';
export const SET_PAYMENT_TYPE = 'SET_PAYMENT_TYPE';


// WEBPACK FOOTER //
// ./src/store/modules/pay-now/mutations.js